export const homePageContent = {
  section0: {
    image:
      process.env.PUBLIC_URL + '/photo/main-page/1_New_team_members_amico.png',
    title: `Any time,
    Anywhere,
    Together forever`,
    description:
      'Mizban brings people together, to spend more quality time. Share what you like to do with your social network and Mizban will help you join together wherever you are.',
  },
  section1: {
    image:
      process.env.PUBLIC_URL + '/photo/main-page/2_Mobile_Marketing_bro.png',
    title: 'Share what you are up to do with your friends and family.',
    description:
      'let your friends know when, where, and what you are up to, so they can get along with you.',
  },
  section2: {
    image: process.env.PUBLIC_URL + '/photo/main-page/3_Schedule_bro.png',
    title: 'Let friends join you and plan it together in just a few clicks',
    description:
      'use the scheduling tools provided to find the best time and location that works best for you all.',
  },
  section3: {
    image:
      process.env.PUBLIC_URL + '/photo/main-page/4_Content_team_rafiki.png',
    title:
      'Find all you need for your gathering from services to products and foods',
    description:
      'By offering discounts and favorite places, Mizban makes it easy and more enjoyable for you and your friends to hang out without any problems.',
  },
  section4: {
    image: process.env.PUBLIC_URL + '/photo/main-page/5_Add_files_bro.png',
    title: 'Save and share your memories forever',
    description:
      'upload your photos and videos to the Mizban event diary to have a shared access with the event participants or publicly as long as you want.',
  },
};
